import React from 'react';
import { useTranslation } from 'react-i18next';
import SerpApiKeywords from '../../../../pages/Articles/GenerateDraft/Keywords/SerpApiKeywords';
import { MAX_KEYWORDS } from '../../lib/sources';

/**
 * Step 4 (keywords): manual keywords and SERP suggestions.
 * Extracted verbatim from pages/Articles/CreateArticle.js.
 */
export default function KeywordsStep({
  effectiveKeywordContext,
  handleAddKeyword,
  handleRemoveKeyword,
  keywordInput,
  keywords,
  language,
  serpKeywordsVisible,
  setKeywordInput,
  setKeywords,
  setSerpKeywordsVisible,
  triggerSerpSearch,
}) {
  const { t } = useTranslation();

  return (
    <section id="seo-keywords" className="mb-8 pt-0">
      <div className="space-y-4">
        <h3 className="text-base font-medium text-gray-800">
          {t('articles.create.keywordForm.selectionHint')}
        </h3>
        {/* Manual keyword input */}
        <div className="flex gap-4">
          <input
            type="text"
            value={keywordInput}
            onChange={(e) => setKeywordInput(e.target.value)}
            placeholder={t('articles.create.keywordForm.placeholder')}
            className="flex-1 rounded-lg border-gray-300 bg-white"
          />
          <button
            onClick={handleAddKeyword}
            disabled={keywords.length >= MAX_KEYWORDS}
            className={`px-4 py-2 max-h-14 rounded-lg ${
              keywords.length >= MAX_KEYWORDS
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                : 'bg-primary-500 text-white hover:bg-primary-600'
            }`}
          >
            {t('articles.create.keywordForm.add')}
          </button>
        </div>

        {/* Add SerpAPI Keywords component */}
        {serpKeywordsVisible && (
          <SerpApiKeywords
            articleContext={effectiveKeywordContext}
            keywords={keywords}
            onKeywordSelect={(keyword) => {
              if (keywords.includes(keyword)) return;
              if (keywords.length >= MAX_KEYWORDS) {
                return;
              }
              setKeywords([...keywords, keyword]);
            }}
            onKeywordRemove={handleRemoveKeyword}
            maxKeywords={MAX_KEYWORDS}
            triggerSearch={triggerSerpSearch}
            language={language}
            key="serp-keywords-component"
            onSearchComplete={() => { }}
            onClose={() => setSerpKeywordsVisible(false)}
          />
        )}
      </div>

    </section>
  );
}
